// extracted by mini-css-extract-plugin
module.exports = {"root":"style_root__4ldia","mobile":"style_mobile__ojwe6","tablet":"style_tablet__upZ8h","desktop":"style_desktop__haHBK"};